import resolveConfig from 'tailwindcss/resolveConfig';

import tailwindConfig from '../../tailwind.config.js';

const fullConfig = resolveConfig(tailwindConfig);

function convertCubicToFramer(cubic: string) {
  const matches = cubic.match(
    /^cubic-bezier\(([0-9\.]+)\,\s?([0-9\.]+)\,\s?([0-9\.]+)\,\s?([0-9\.]+)\)$/,
  );
  if (!matches) return null;
  return [
    parseFloat(matches[1]),
    parseFloat(matches[2]),
    parseFloat(matches[3]),
    parseFloat(matches[4]),
  ];
}

export function getEaseMicro() {
  return convertCubicToFramer(
    fullConfig.theme.transitionTimingFunction['micro-enter'],
  );
}
